<div class="modal-header">
  <h4 class="modal-title">Assign Driver</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>
<form [formGroup]="form" (ngSubmit)="save()">
  <div class="modal-body">
    <!-- Select Vehicle Type -->
    <div class="mb-3">
      <label class="form-label">Select Vehicle Type *</label>
      <ng-select
        class="truck-number"
        aria-label="Default select example"
        placeholder="Select Vehicle Type"
        formControlName="vehicleType"
      >
        <ng-container *ngFor="let item of vehicleTypeList; let i = index">
          <ng-option value="{{ item?.name }}">
            <h5>{{ item?.name }}</h5>
          </ng-option>
        </ng-container>
      </ng-select>
      <div
        *ngIf="
          f['vehicleType'].invalid &&
          (f['vehicleType'].dirty || f['vehicleType'].touched)
        "
        class="text-danger small"
      >
        Vehicle Type is required
      </div>
    </div>
    <!-- Select Vehicle Type -->
    <div class="mb-3">
      <label class="form-label">Select Vehicle Number *</label>
      <ng-select
        class="truck-number"
        aria-label="Default select example"
        placeholder="Select Vehicle Type"
        formControlName="tempoId"
      >
        <ng-container *ngFor="let item of vehicleList; let i = index">
          <ng-option value="{{ item?._id }}">
            <h5>{{ item?.tempoNumber }}</h5>
          </ng-option>
        </ng-container>
      </ng-select>
      <div
        *ngIf="
          f['tempoId'].invalid && (f['tempoId'].dirty || f['tempoId'].touched)
        "
        class="text-danger small"
      >
        Vehicle Number is required
      </div>
    </div>
    <!-- Select Driver -->
    <div class="mb-3">
      <label class="form-label">Select Driver *</label>
      <ng-select
        class="truck-number"
        aria-label="Default select example"
        placeholder="Select Vehicle Type"
        formControlName="driverId"
      >
        <ng-container *ngFor="let item of driverList; let i = index">
          <ng-option value="{{ item?._id }}">
            <h5>{{ item?.name }}</h5>
          </ng-option>
        </ng-container>
      </ng-select>
      <div
        *ngIf="
          f['driverId'].invalid &&
          (f['driverId'].dirty || f['driverId'].touched)
        "
        class="text-danger small"
      >
        Driver is required
      </div>
    </div>

    <!-- Delivery Address -->
    <div class="mb-3">
      <label class="form-label">Delivery Address *</label>
      <ng-select
        class="truck-number"
        aria-label="Default select example"
        placeholder="Select Vehicle Type"
        formControlName="deliveryAddress"
      >
        <ng-container *ngFor="let item of companyAddresses; let i = index">
          <ng-option value="{{ item?._id }}">
            <h5>{{ item?.companyName }}</h5>
          </ng-option>
        </ng-container>
      </ng-select>
      <div
        *ngIf="
          f['deliveryAddress'].invalid &&
          (f['deliveryAddress'].dirty || f['deliveryAddress'].touched)
        "
        class="text-danger small"
      >
        Delivery Address is required
      </div>
    </div>
    <!-- Notes -->
    <div class="mb-3">
      <label class="form-label">Notes</label>
      <textarea
        rows="4"
        class="form-control"
        formControlName="notes"
      ></textarea>
    </div>
  </div>
  <div *ngIf="!isViewMode" class="modal-footer">
    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="loading || isViewMode || form.invalid"
    >
      Vehicle Assign
    </button>
  </div>
</form>
